/* unplugin-vue-components disabled */import { render } from "./empty-cart.vue?vue&type=template&id=4add35ee"
import script from "./empty-cart.vue?vue&type=script&lang=js"
export * from "./empty-cart.vue?vue&type=script&lang=js"

import "./empty-cart.vue?vue&type=style&index=0&id=4add35ee&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__